// src/pages/categoryData.js
// Add more categories/subs/images anytime (NO pricing)
export const CATEGORY_DATA = {
  rings: {
    title: "Rings",
    desc:
      "A small circle that holds big promises — crafted to celebrate love, milestones, and everyday elegance.",
    hero: "/assets/products/cat/rings-hero.jpg",
    subs: [
      { slug: "gold", title: "Gold Rings", img: "/assets/products/cat/rings-gold.jpg" },
      { slug: "silver", title: "Silver Rings", img: "/assets/products/cat/rings-silver.jpg" },
      { slug: "diamond", title: "Diamond Rings", img: "/assets/products/cat/rings-diamond.jpg" },
      { slug: "gifts", title: "Gift Rings", img: "/assets/products/cat/rings-gifts.jpg" },
      { slug: "baby", title: "Baby Rings", img: "/assets/products/cat/rings-baby.jpg" },
      { slug: "personalized", title: "Personalized Rings", img: "/assets/products/cat/rings-personalized.jpg" },
    ],
  },

  bangles: {
    title: "Bangles",
    desc:
      "From festive grandeur to graceful daily wear — bangles that echo tradition and shine with modern finesse.",
    hero: "/assets/products/cat/bangles-hero.jpg",
    subs: [
      { slug: "gold", title: "Gold Bangles", img: "/assets/products/gold1.png" },
      { slug: "silver", title: "Silver Bangles", img: "/assets/products/cat/bangles-silver.jpg" },
      { slug: "diamond", title: "Diamond Bangles", img: "/assets/products/cat/bangles-diamond.jpg" },
      { slug: "gifts", title: "Gift Bangles", img: "/assets/products/cat/bangles-gifts.jpg" },
      { slug: "baby", title: "Baby Bangles", img: "/assets/products/cat/bangles-baby.jpg" },
      { slug: "personalized", title: "Personalized Bangles", img: "/assets/products/cat/bangles-personalized.jpg" },
    ],
  },

  chains: {
    title: "Chains",
    desc:
      "Timeless layers that elevate every look — designed to sit perfectly, sparkle subtly, and last for years.",
    hero: "/assets/products/cat/chains-hero.jpg",
    subs: [
      { slug: "gold", title: "Gold Chains", img: "/assets/products/cat/chains-gold.jpg" },
      { slug: "silver", title: "Silver Chains", img: "/assets/products/cat/chains-silver.jpg" },
      { slug: "diamond", title: "Diamond Chains", img: "/assets/products/cat/chains-diamond.jpg" },
      { slug: "gifts", title: "Gift Chains", img: "/assets/products/cat/chains-gifts.jpg" },
      { slug: "baby", title: "Baby Chains", img: "/assets/products/cat/chains-baby.jpg" },
      { slug: "personalized", title: "Personalized Chains", img: "/assets/products/cat/chains-personalized.jpg" },
    ],
  },

  "customized-gifts": {
    title: "Customized Gifts",
    desc:
      "Turn memories into treasures — meaningful gifts crafted with care for the moments that matter most.",
    hero: "/assets/products/cat/gifts-hero.jpg",
    subs: [
      { slug: "gold", title: "Gold Gifts", img: "/assets/products/cat/gifts-gold.jpg" },
      { slug: "silver", title: "Silver Gifts", img: "/assets/products/cat/gifts-silver.jpg" },
      { slug: "diamond", title: "Diamond Gifts", img: "/assets/products/cat/gifts-diamond.jpg" },
      { slug: "gifts", title: "Occasion Gifts", img: "/assets/products/cat/gifts-occasion.jpg" },
      { slug: "baby", title: "Baby Gifts", img: "/assets/products/cat/gifts-baby.jpg" },
      { slug: "personalized", title: "Personalized Gifts", img: "/assets/products/cat/gifts-personalized.jpg" },
    ],
  },

  anklets: {
    title: "Anklets",
    desc:
      "A gentle shimmer with every step — anklets that feel light, look elegant, and stay forever charming.",
    hero: "/assets/products/cat/anklets-hero.jpg",
    subs: [
      { slug: "gold", title: "Gold Anklets", img: "/assets/products/cat/anklets-gold.jpg" },
      { slug: "silver", title: "Silver Anklets", img: "/assets/products/cat/anklets-silver.jpg" },
      { slug: "diamond", title: "Diamond Anklets", img: "/assets/products/cat/anklets-diamond.jpg" },
      { slug: "gifts", title: "Gift Anklets", img: "/assets/products/cat/anklets-gifts.jpg" },
      { slug: "baby", title: "Baby Anklets", img: "/assets/products/cat/anklets-baby.jpg" },
      { slug: "personalized", title: "Personalized Anklets", img: "/assets/products/cat/anklets-personalized.jpg" },
    ],
  },

  coins: {
    title: "Coins",
    desc:
      "Blessings you can hold — pure, auspicious, and crafted for pooja, gifting, and special beginnings.",
    hero: "/assets/products/cat/coins-hero.jpg",
    subs: [
      { slug: "gold", title: "Gold Coins", img: "/assets/products/cat/coins-gold.jpg" },
      { slug: "silver", title: "Silver Coins", img: "/assets/products/cat/coins-silver.jpg" },
      { slug: "diamond", title: "Diamond Coins", img: "/assets/products/cat/coins-diamond.jpg" },
      { slug: "gifts", title: "Gift Coins", img: "/assets/products/cat/coins-gifts.jpg" },
      { slug: "baby", title: "Baby Coins", img: "/assets/products/cat/coins-baby.jpg" },
      { slug: "personalized", title: "Personalized Coins", img: "/assets/products/cat/coins-personalized.jpg" },
    ],
  },
};
